import { render, staticRenderFns } from "./userimage.html?vue&type=template&id=99a14ed6&scoped=true&"
import script from "./userimage.js?vue&type=script&lang=js&"
export * from "./userimage.js?vue&type=script&lang=js&"
import style0 from "./userimage.scss?vue&type=style&index=0&id=99a14ed6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a14ed6",
  null
  
)

export default component.exports